import React from 'react';
import { NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';
import { LayoutDashboardIcon, LightbulbIcon, PenToolIcon, CalendarIcon, MapPinIcon, UsersIcon, BarChart3Icon, SettingsIcon, ChevronLeftIcon, SparklesIcon } from 'lucide-react';
interface SidebarProps {
  collapsed: boolean;
  onToggle: () => void;
}
const navItems = [{
  path: '/dashboard',
  icon: LayoutDashboardIcon,
  label: 'Dashboard'
}, {
  path: '/content-ideas',
  icon: LightbulbIcon,
  label: 'Content Ideas'
}, {
  path: '/post-composer',
  icon: PenToolIcon,
  label: 'Post Composer'
}, {
  path: '/campaigns',
  icon: CalendarIcon,
  label: 'Campaigns'
}, {
  path: '/local-intelligence',
  icon: MapPinIcon,
  label: 'Local Intelligence'
}, {
  path: '/collaboration',
  icon: UsersIcon,
  label: 'Collaboration'
}, {
  path: '/analytics',
  icon: BarChart3Icon,
  label: 'Analytics'
}, {
  path: '/settings',
  icon: SettingsIcon,
  label: 'Settings'
}];
export function Sidebar({
  collapsed,
  onToggle
}: SidebarProps) {
  return <motion.aside initial={false} animate={{
    width: collapsed ? 80 : 280
  }} transition={{
    duration: 0.3,
    ease: 'easeInOut'
  }} className="bg-white dark:bg-gray-900 border-r border-gray-200 dark:border-gray-800 flex flex-col" data-id="element-66">
      <div className="h-16 flex items-center justify-between px-6 border-b border-gray-200 dark:border-gray-800" data-id="element-67">
        {!collapsed && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="flex items-center gap-2" data-id="element-68">
            <SparklesIcon className="w-6 h-6 text-purple-600" data-id="element-69" />
            <span className="font-bold text-lg bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent" data-id="element-70">
              GeoPulse AI
            </span>
          </motion.div>}
        <button onClick={onToggle} className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors" data-id="element-71">
          <ChevronLeftIcon className={`w-5 h-5 transition-transform ${collapsed ? 'rotate-180' : ''}`} data-id="element-72" />
        </button>
      </div>
      <nav className="flex-1 py-6 px-3 space-y-1" data-id="element-73">
        {navItems.map(item => <NavLink key={item.path} to={item.path} className={({
        isActive
      }) => `flex items-center gap-3 px-3 py-3 rounded-xl transition-all group ${isActive ? 'bg-purple-50 dark:bg-purple-900/20 text-purple-600 dark:text-purple-400' : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800'}`} data-id="element-74">
            {({
          isActive
        }) => <>
                <item.icon className={`w-5 h-5 ${isActive ? 'text-purple-600 dark:text-purple-400' : ''}`} data-id="element-75" />
                {!collapsed && <motion.span initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} className="font-medium" data-id="element-76">
                    {item.label}
                  </motion.span>}
              </>}
          </NavLink>)}
      </nav>
    </motion.aside>;
}